export default __webpack_public_path__ + "static/media/coin.81bba524.png";